import { isEqual, isObject, transform } from 'lodash';

export function objectSubtract(originalObject, originalBase) {
  function changes(object, base) {
    const accumulator = {};

    return transform(
      object,
      (acc, value, key) => {
        if (base[key] === undefined) {
          acc[key] = value;
        } else if (!isEqual(value, base[key])) {
          acc[key] =
            isObject(value) && isObject(base[key])
              ? changes(value, base[key])
              : value;
        }
      },
      accumulator,
    );
  }

  return changes(originalObject, originalBase);
}
